import axiosInstance from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/config';

export interface MyAnnouncement {
  id: number;
  title: string;
  message: string;
  priority: 'low' | 'normal' | 'high' | 'urgent';
  is_read: boolean;
  created_at: string;
}

const announcementService = {
  async getAnnouncements(): Promise<MyAnnouncement[]> {
    const response = await axiosInstance.get(API_ENDPOINTS.myAnnouncements);
    const data = response.data;
    return Array.isArray(data) ? data : data.results || [];
  },

  async markAsRead(id: number): Promise<void> {
    await axiosInstance.post(API_ENDPOINTS.markAnnouncementRead(id));
  },
};

export default announcementService;